<template>
  <section class="register">
    <div class="truck-apply-tip">
      <div class="l">
        正在申请 货车ETC
      </div>
      <div
        class="r"
        @click="m_customService"
      >
        <img
          class="icon"
          src="https://wecos.etczs.net/pages/truck/service-black.png"
          mode="aspectFit"
        />
      </div>
    </div>
    <div class="main">
      <div class="title">车牌类型</div>
      <div class="plate-color-list">
        <div class="plate-color-item truck">
          <img
            class="item-bg"
            :src="plateBg"
          />
          <div
            class="item-text"
            v-bind:class="{ white: plateInfo['color'] === '蓝色' }"
          >{{ plateInfo['color'] }}</div>
        </div>
        <div
          class="plate-color-item color-picker"
          id="plateColorPicker"
        >更换类型</div>

      </div>
      <div class="title">车牌</div>
      <div class="input-box">
        <div
          v-for="(v, i) in plateNos"
          class="palte-i"
          :class="{'point': i===2, 'eight': i===8, 'focus': (focusIndex===i && i!==2)}"
          :key="i"
          @click="tapPlateInput(i)"
        >
          <template v-if="i!==8 || v">{{v}}</template>
          <template v-else>
            <img src="https://wecos.etczs.net/pages/truck/plate-eight-add.png" />
          </template>
        </div>
      </div>
      <div
        class="btn submit"
        @click="submit"
      >确定办理</div>
    </div>

    <Popup
      ref="popup"
      class="poster-con"
    >
      <div
        slot="content"
        class="poster"
      >
        <img
          class="poster-img"
          :src="posterImg"
          width="620"
          height="952"
        >
      </div>
    </Popup>

    <PlateNoBoard
      @keyBoardChange="keyBoardChangeEvent($event)"
      v-model="focusIndex"
    ></PlateNoBoard>
    <canvas
      style="display:none;"
      id="code-poster"
      width="620"
      height="952"
    >
      <p>你的浏览器不支持Canvas</p>
    </canvas>

  </section>

</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
import ChannelMixin from '@/mixins/channelMixin'

import MobileSelect from 'mobile-select'
import PlateNoBoard from '@/components/etc.plateNoBoard'
import Popup from '@/components/cool.popup'
import reconApply from '@/api/reconApply.api'

import bgImg from '@/assets/truck/h5-truck-poster-bg.png'
import commonCode from '@/assets/truck/pages-index-code.png'
const TRUCK_PLATE_COLOR = [
  { id: 1, color: '黄色' },
  { id: 0, color: '蓝色' },
  { id: 4, color: '渐变绿色' },
  { id: 5, color: '黄绿双拼' }
  // '蓝色', '渐变绿色', '黄色', '黄绿双拼'
]

const PLATE_COLOR_IMG_NAME = {
  黄绿双拼: 'truck-yello-green.png',
  黄色: 'truck-yellow-1101.png',
  渐变绿色: 'green-plate-0901.png',
  蓝色: 'blue-plate-0901.png'
}

export default {
  name: 'register',
  mixins: [FunMixin, ChannelMixin],
  components: {
    PlateNoBoard,
    Popup
  },
  data() {
    return {
      posterImg: bgImg,
      focusIndex: null,
      plateNos: ['', '', '', '', '', '', '', '', ''],
      plate: '',
      plateInfo: TRUCK_PLATE_COLOR[0]
    }
  },
  computed: {
    plateBg() {
      return `https://wecos.etczs.net/assets/images/${
        PLATE_COLOR_IMG_NAME[this.plateInfo['color']] ||
        'truck-no-choose-color-1101.png'
      }`
    }
  },
  methods: {
    async keyBoardChangeEvent(e) {
      console.log(e)
      if (e.type === 'tapKey') {
        this.plateNos[this.focusIndex] = e.val
        this.cantChoosePlateC =
          this.plateNos.slice(0, 8).join('').length >= 7 &&
          this.plateNos.join('').length
        this.$forceUpdate()
        if (this.focusIndex === 8) return
        this.focusIndex++
        if (this.focusIndex === 2) this.focusIndex++
      } else if (e.type === 'confirmKey') {
        // if (this.plateNos.join('').length >= 7) {
        //   await NewApplyApi.checkPlateNo({plate_no: this.plateNos.join('')})
        // }
        this.focusIndex = null
      } else if (e.type === 'deleteKey') {
        this.plateNos[this.focusIndex] = ''
        this.cantChoosePlateC =
          this.plateNos.slice(0, 8).join('').length >= 7 &&
          this.plateNos.join('').length
        this.$forceUpdate()
        if (this.focusIndex === 0) return
        this.focusIndex--
        if (this.focusIndex === 2) this.focusIndex--
      }
    },
    // 选择车牌输入框
    async tapPlateInput(i) {
      await this.m_clickDebounce('tapPlateInput')
      if (i === 2) return
      this.focusIndex = i
    },
    async submit() {
      await this.m_clickDebounce('submit')
      const plateNo = this.plateNos.join('')
      if (!this.plateInfo || !plateNo) return
      this.m_showLoading()

      reconApply
        .truckSubmitApplyInfo({
          plate_no: plateNo,
          plate_color: this.plateInfo.id,
          entry: 1470,
          pl: 400
        })
        .then((res) => {
          // 1进行中 2不可办理 3可办理
          const title = '车牌' + plateNo
          switch (res.apply_status) {
            case 1:
              this.m_showConfirm({
                title: title + '已在办理中',
                content: '请进入微信“ETC助手”小程序继续办理',
                noCancel: true,
                confirmBtn: '前往办理'
              }).then(() => {
                this.codeLoad(commonCode)
              })
              break
            case 2:
              this.m_showConfirm({
                title: title + '已发行',
                content: '无法重复办理。交通部规定一辆车仅能办理一套ETC记账卡套餐，专车专用',
                noCancel: true,
                confirmBtn: '我知道了'
              })
              this.m_loadingClose()
              break
            case 3:
              this.m_showConfirm({
                title: title + '可办理',
                content: '请进入微信“ETC助手”小程序继续办理，现办理高速通行可享低至85折优惠',
                noCancel: true,
                confirmBtn: '前往办理'
              }).then(() => {
                localStorage.setItem('TRUCK_PLATE_NO', this.plateNos)
                localStorage.setItem('TRUCK_PLATE_INFO', JSON.stringify(this.plateInfo))

                this.codeLoad(res.url)
              })
              break
            default:
              this.m_loadingClose()
              break
          }
        })
        .catch(() => {
          this.m_loadingClose()
        })
    },
    bgLoad() {
      this.posterCanvas = document.getElementById('code-poster')
      this.ctx = this.posterCanvas.getContext('2d')
      // const imageBg = document.querySelector('.source');
      const imageBg = new Image()

      imageBg.src = bgImg
      imageBg.onload = () => {
        this.ctx.drawImage(imageBg, 0, 0, 620, 952) // this即是imgObj,保持图片的原始大小：470*480

        // setTimeout(() => {
        //   this.codeLoad('https://wecos.etczs.net/assets/images/truck-no-choose-color-1101.png')
        // }, 1000);
      }
      // posterBg
    },
    codeLoad(codeSrc) {
      // const imageCode = document.querySelector('.code');
      const imageCode = new Image()
      imageCode.setAttribute('crossOrigin', 'Anonymous')
      imageCode.crossOrigin = 'Anonymous'
      imageCode.src = codeSrc
      imageCode.onload = () => {
        this.m_loadingClose()

        this.ctx.clearRect(108, 266, 400, 400)
        this.ctx.fillStyle = '#ffffff'
        this.ctx.fillRect(108, 266, 400, 400);
        this.ctx.drawImage(imageCode, 108, 266, 400, 400) // this即是imgObj,保持图片的原始大小
        this.posterImg = this.posterCanvas.toDataURL('image/png', 1.0)
        this.$refs.popup.$emit('showPopup', { wrapClass: 'wrap-trans', maskHide: true })
        this.m_loadingClose()
      }
    },
    pageInit() {
      this.plateNos = (localStorage.getItem('TRUCK_PLATE_NO') && localStorage.getItem('TRUCK_PLATE_NO').split(',')) || this.plateNos
      this.plateInfo = JSON.parse(localStorage.getItem('TRUCK_PLATE_INFO')) || this.plateInfo
      const that = this
      // eslint-disable-next-line
      new MobileSelect({
        trigger: '#plateColorPicker',
        title: '',
        wheels: [{ data: TRUCK_PLATE_COLOR }],
        keyMap: {
          id: 'id',
          value: 'color'
        },
        callback(index, data) {
          console.log(index, data)
          that.plateInfo = data[0]
          // that.activePlateColor = data[0].color
          // that.plateId = data[0].id
        }
      })
    }
  },
  mounted() {
    this.bgLoad()
    this.pageInit()
  },
  created() {
    this.c_channelLogin()
  }
}
</script>

<style scoped lang="scss">

.register {
  background-color: #f8f7f6;
  display: flex;
  flex-direction: column;
}
.truck-apply-tip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 136px;
  padding: 0 40px;
  background-color: #f7f7f7;
  .l {
    font-size: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 56px;
  }
  .r {
    width: 48px;
    height: 48px;
    display: block;
    image {
      width: 100%;
      height: 100%;
    }
  }
}
.main {
  flex: 1;

  background: #ffffff;
  box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.07);
  border-radius: 32px 32px 0px 0px;
  padding: 40px;
  .title {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 48px;
  }
}

.plate-color-title {
  position: relative;
  padding: 10px 40px 0 40px;
  font-size: 32px;
  font-weight: 500;
  line-height: 45px;
  color: #333;
}
.plate-color-list {
  padding: 20px 0px 60px;
  display: flex;
}
.plate-color-item {
  margin-right: 20px;
  position: relative;
  box-sizing: border-box;
  border-radius: 8px;
  min-width: 210px;
  height: 78px;
  text-align: center;
  line-height: 78px;
  font-size: 32px;
  padding: 0 10px;
  .item-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .item-text {
    position: relative;
    width: 100%;
    left: 0;
    top: 0px;
    font-size: 28px;
    color: #333;
    &.white {
      color: #fff;
    }
    text {
      vertical-align: middle;
      display: inline-block;
    }
    .text {
      margin-right: 20px;
    }
  }
  .plate-color-selected {
    display: none;
  }
  &.active {
    font-weight: bold;
    .plate-color-selected {
      display: block;
      position: absolute;
      width: 36px;
      height: 36px;
      right: -13px;
      bottom: -10px;
    }
  }
  &.blue {
    color: #fff;
  }
  &.yellow {
    color: #f4c12c;
    border: 2px solid #f4c12c;
    &.active {
      background-color: #f4c12c;
      color: #333;
    }
  }
  &.green {
    color: #333;
  }
  &.other {
    color: #999;
  }
}

.plate-color-tips {
  padding: 0 40px;
  font-size: 24px;
  line-height: 33px;
  color: #999999;
}

.color-picker {
  border: 1px solid #ccc;
  position: relative;
  border-radius: 8px;
  color: #333;
  text-align: left;

  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 44%;
    width: 20px;
    height: 20px;
    border-left: 1px solid #999;
    border-bottom: 1px solid #999;
    transform: translateY(-50%) rotate(-45deg);
    right: 20px;
  }
}
.input-box {
  display: flex;
  align-items: center;
  .palte-i {
    font-weight: bold;
    width: 66px;
    height: 84px;
    line-height: 84px;
    border-radius: 4px;

    border: 2px solid #999999;
    box-sizing: border-box;
    margin-right: 16px;
    text-align: center;

    font-size: 36px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    &.point {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #999;
      border: none;
      margin-right: 16px;
    }

    &.focus {
      position: relative;
      &:after {
        content: '';
        position: absolute;
        box-sizing: border-box;
        top: -2px;
        left: -2px;
        height: 84px;
        width: 66px;
        border: 2px solid #16c88b;
        border-radius: 8px;
        animation: blink 1s infinite;
      }
      border-color: transparent;
      color: #16c88b;
    }
    &.eight {
      border: 2px dashed #999999;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
}
.btn {
  margin: 116px auto 0;
  height: 92px;
  background: #0ed49b;
  border-radius: 46px;

  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 92px;
  text-align: center;
  &.submit {
    width: 640px;
  }
}

.poster {
  .poster-img {
    width: 620px;
    height: 952px;
  }
}
#code-poster {
  width: 620px;
  height: 952px;
}

@keyframes blink {
  0% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
</style>
